<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" @click="goToDashboard()" href="#">{{
        $t('common.labels.dashboard')
      }}</a>
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
          <!-- <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li>-->
          <!-- <drop-down tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">0</span>
            </template>
            <a class="dropdown-item" href="#">...</a>
          </drop-down>-->

          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>-->
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link
              :to="{ path: '/app/profile' }"
              class="nav-link text-danger user-details"
              v-if="$store.state.user._id"
              >{{
                $store.state.user.firstname + ' ' + $store.state.user.lastname
              }}</router-link
            >
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0);"
              id="logout"
              class="logout nav-link text-danger"
              @click="logout()"
            >
              <i class="nc-icon nc-button-power"></i>
              <span style="margin-left: 5px;">{{
                $t('common.labels.logout')
              }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    goToDashboard() {
      this.$router.push('/app/overview');
    },
  },
};
</script>
<style></style>
